import React from "react";
import $ from "jquery";
import "./L6C1.css";
import Card from "@material-ui/core/Card";
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import cb0 from "static/images/l1c1/cb-0.png";
import cb1 from "static/images/l1c1/cb-1.png";
import cb2 from "static/images/l1c1/cb-2.png";
import cb3 from "static/images/l1c1/cb-3.png";
import cb4 from "static/images/l1c1/cb-4.png";
import cb5 from "static/images/l1c1/cb-5.png";
import cb6 from "static/images/l1c1/cb-6.png";
import cb7 from "static/images/l1c1/cb-7.png";
import cb8 from "static/images/l1c1/cb-8.png";
import cb9 from "static/images/l1c1/cb-9.png";
import tb0 from "static/images/l1c1/tb-0.png";
import tb1 from "static/images/l1c1/tb-1.png";
import tb2 from "static/images/l1c1/tb-2.png";
import tb3 from "static/images/l1c1/tb-3.png";
import tb4 from "static/images/l1c1/tb-4.png";
import tb5 from "static/images/l1c1/tb-5.png";
import tb6 from "static/images/l1c1/tb-6.png";
import tb7 from "static/images/l1c1/tb-7.png";
import tb8 from "static/images/l1c1/tb-8.png";
import tb9 from "static/images/l1c1/tb-9.png";
import td0 from "static/images/l6c1/land0.png"
import td1 from "static/images/l6c1/land1.png"
import td2 from "static/images/l6c1/land2.png"
import td3 from "static/images/l6c1/land3.png"
import td4 from "static/images/l6c1/land4.png"
import cbIcon from "static/images/l6c1/cbIcon.png";

import { withSnackbar } from 'notistack';

import Button from '@material-ui/core/Button';
const isNumber = require('is-number');


var local;

const cbs = [cb0, cb1, cb2, cb3, cb4, cb5, cb6, cb7, cb8, cb9];
const tbs = [tb0, tb1, tb2, tb3, tb4, tb5, tb6, tb7, tb8, tb9];
const tds = [td0, td1, td2, td3, td4]

var langDict = ["中文", "English", "日本語", "Deutsch", "русский язык", "한국어"];
var langAbbr = ["zh", "en", "ja", "de", "ru", "kr"];


// 部分组件
const sliderStyle = {
  margin: "20px",
  width: "100%"
};

// safe guard
function getNumber(number) {
  if (isNumber(number)) return parseInt(number);
  return 0;
}
class L6c1 extends React.Component {
  colors = [
    "#1abc9c",
    "#2ecc71",
    "#3498db",
    "#9b59b6",
    "#34495e",
    "#f1c40f",
    "#e67e22",
    "#e74c3c",
    "#ecf0f1",
    "#95a5a6"
  ];
  races = ["人类", "精灵", "兽人", "地精", "亡灵"];
  scale = ["小型城堡", "中型城堡", "大型城堡"];
  eco = [6, 8, 3, 7, 4];
  fire = [6, 3, 8, 4, 7];
  cdata = [];
  landProps = [0, 0.75,0.15,0.08,0.02, 0]
  growthRate = [0, 0.05, 0.1, 0.2, 0.4, 0]
  interId = null
  

  snackbarJump = (type, message) => {
    this.props.enqueueSnackbar(message, {
        variant: type,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        },
        autoHideDuration: 3000,
    });
  };

  constructor(props) {
    super(props);

    local = require("./L6C1l"+langAbbr[getNumber(props.lang)]+".js")

    this.state = {
      middleHeight: window.innerHeight,
      cbType: 0,
      cbColor: 0,
      hbWhere: 0,
      hbColor: 0,
      hbType: 0,
      race: 0,
      size: 0,
      special: 0,
      castleRank: 1,
      castleScore: 0,
      waitTime: 0,
      tdType: 0

    };

    if (sessionStorage.getItem("mycastle") === null) {
      sessionStorage.setItem("mycastle", [0, 0, 0, 0, 0, 0, 0, 0]);
    }
  }

  componentWillMount() {
    if (sessionStorage.getItem("mycastle")) {
      this.cdata = sessionStorage.getItem("mycastle").split(",");

      this.setState({
        cbType: getNumber(this.cdata[1]),
        cbColor: getNumber(this.cdata[2]),
        hbWhere: getNumber(this.cdata[5]),
        hbColor: getNumber(this.cdata[4]),
        hbType: getNumber(this.cdata[3]),
        race: getNumber(this.cdata[6]),
        size: getNumber(this.cdata[0]),
        special: getNumber(this.cdata[7])
      });
    }

    if (sessionStorage.getItem("castleRank") === null){
      this.setState({
        castleScore: this.eco[getNumber(this.cdata[5])],
        castleRank: 1
      })
      sessionStorage.setItem("castleScore", this.eco[getNumber(this.cdata[5])])
      sessionStorage.setItem("castleRank", 1)
    }
    else{
      this.setState({
        castleScore: sessionStorage.getItem("castleScore"),
        castleRank: getNumber(sessionStorage.getItem("castleRank"))
      })
    }
  }

  componentWillUpdate(nextProps, nextState){
    local = require("./L6C1l"+langAbbr[getNumber(nextProps.lang)]+".js")
  }

  componentDidMount = () => {
    this.changepic();
  };

  componentWillUnmount = () => {
   
  };

  annexLand = () =>{
    this.setState({
      waitTime: 10,
    })
    this.interId = setInterval(()=>{ 
      this.setState({waitTime: this.state.waitTime-1})
      if(this.state.waitTime <= 0) {
        clearInterval(this.interId)
      }
  }, 1000);
    let result = Math.random()
    let land = 0
    if (result < 0.75){
      land = 1
    }else if(result < 0.9){
      land = 2
    }else if(result < 0.98){
      land = 3
    }else{
      land = 4
    }
    this.setState({
      tdType: land,
    })
    this.snackbarJump("info", local.local.random + land)
    let newScore = Math.round(this.state.castleScore * (1+this.growthRate[land]) * 10) / 10
    setTimeout(() => {
      this.snackbarJump("success", local.local.annex + newScore)
      this.upgrade(newScore)
    },5000)  
    

  }

  upgrade = (newScore) => {
    sessionStorage.setItem("castleScore", newScore)
    this.setState({
      castleScore: newScore
    })
    if(newScore > 10*this.state.castleRank+Math.pow(2,this.state.castleRank)){
      this.snackbarJump("success", local.local.levelup + parseInt(this.state.castleRank + 1))
      sessionStorage.setItem("castleRank", this.state.castleRank + 1)
      this.setState({
        castleRank: this.state.castleRank + 1
      })
      
    }
  }

  changepic = () => {
    // 徽标位置
    switch (this.state.hbWhere % 4) {
      case 1:
        $("#hbbox").css("top", "0%");
        $("#hbbox").css("left", "100%");
        $("#hbbox").css("transform", "translate(-80%, -20%)");
        break;
      case 2:
        $("#hbbox").css("top", "100%");
        $("#hbbox").css("left", "0%");
        $("#hbbox").css("transform", "translate(-20%, -80%)");
        break;
      case 3:
        $("#hbbox").css("top", "100%");
        $("#hbbox").css("left", "100%");
        $("#hbbox").css("transform", "translate(-80%, -80%)");
        break;
      default:
        $("#hbbox").css("top", "0%");
        $("#hbbox").css("left", "0%");
        $("#hbbox").css("transform", "translate(-20%, -20%)");
        break;
    }
  };

  render() {
    return (
      <div className="configContainer">
        <div className="headerNote">
          <h3>{local.local.instruction}</h3>
        </div>
        <div className="row">
          <div className="clash-card barbarian">
            <div className="clash-card__image clash-card__image--barbarian">
              <img
                src={cbs[getNumber(this.state.cbType)]}
                alt="eye"
                style={{
                  filter: "hue-rotate(" + this.state.cbColor * 30 + "deg)"
                }}
              />

              <div
                id="hbbox"
                className="hbbox"
                style={{ position: "absolute", width: "5vw", padding: "4%" }}
              >
                <img
                  src={tbs[getNumber(this.state.hbType)]}          
                  alt="tb"
                  style={{
                    position: "relative", width: "100%",
                    filter: "brightness(50%) sepia(100) saturate(25) hue-rotate(" + this.state.hbColor * 30 + "deg)"
                  }}
                  id="hb"
                />
              </div>
            </div>

            <div className="clash-card__level clash-card__level--barbarian">
              Level {this.state.castleRank}
            </div>
            <div className="clash-card__unit-description">{local.local.serialNumber}</div>
            <div className="clash-card__unit-name">
              {this.state.size}
              {this.state.cbType}
              {this.state.cbColor}
              {this.state.hbType}
              {this.state.hbColor}
              {this.state.hbWhere}
              {this.state.race}
              {this.state.special}
            </div>
            <div className="clash-card__unit-description">
              {local.local.scale[this.state.size % 3]}
              <br />
              {local.local.specialid}：{this.state.special}
            </div>

            <div className="clash-card__unit-stats clash-card__unit-stats--barbarian clearfix">
              <div className="one-third">
                <div className="chinese">{local.local.races[this.state.race % 5]}</div>
                <div className="stat-value">{local.local.race}</div>
              </div>

              <div className="one-third">
                <div className="stat">{this.state.castleScore}</div>
                <div className="stat-value">{local.local.economic}</div>
              </div>

              <div className="one-third no-border">
                <div className="stat">{this.fire[this.state.race % 5]}</div>
                <div className="stat-value">{local.local.military}</div>
              </div>
            </div>
          </div>

         
                
          <div className="config-card-content">
                  <Card className="config-card config-card-middle">
                  
                  <div className="config-title">
                  {local.local.hint}
                  </div>
                  <div className="config-content chinese">
                  {local.local.hintDetail}
                  </div>
                  <div className="config-title">
                  {local.local.castleInformation}
                  </div>
                  <div>
                  <img src={cbIcon} alt="castle-icon" className="config-icon"/>
                  <span className="config-info config-content chinese">
                  {local.local.castleLevel}:  <strong>{this.state.castleRank}</strong> <br />
                  {local.local.castleEconomy}:  <strong>{this.state.castleScore} / {10*this.state.castleRank+Math.pow(2,this.state.castleRank)} </strong>
                  </span>
                  </div>
                  
                  <div className="config-add-margin">
                    <BorderLinearProgress 
                      variant="determinate"
                      color="secondary"
                      value={100 * this.state.castleScore / (10*this.state.castleRank+Math.pow(2,this.state.castleRank))}
                    />
                  </div>
                  <div className="config-title">
                  {local.local.annexLand}
                  </div>
                  <div className="config-add-margin">
                    <ConfigButton onClick={this.annexLand.bind(this)} disabled={this.state.waitTime>0}>
                      {this.state.waitTime>0 ? local.local.annexPrefix + this.state.waitTime+ local.local.annexSuffix : local.local.annexLand}
                    </ConfigButton>
                    </div>
                    {/* <img
                      src={tds[getNumber(this.state.tdType)]}
                      alt="land"
                      style={{
                        height: "20%",
                      }}
                    /> */}
                 
                  </Card>
                  </div>
            
        
        
        
        </div>
      </div>
    );
  }
}


const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    backgroundColor: lighten('#ff6c5c', 0.5),
  },
  bar: {
    borderRadius: 20,
    backgroundColor: '#ff6c5c',
  },
})(LinearProgress);

const ConfigButton = withStyles({
  root: {
    color: 'red',
    width: "100%",
    border:"1px solid red",
    '&:hover': {
      color: "white",
      backgroundColor: 'red',
    },
  },
})(Button);


export default withSnackbar(L6c1);